import React from "react";
import { cn } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";

import * as styles from "../styles/components/fc-2-column-image.module.css";

const TwoColumnImage = (props) => {

  const {
    _key,
    imageLeft,
    imageRight
  } = props;

  return (
    <div className={styles.root} key={_key}>
      <div className="grid">
        <div className={cn("col-12 col-md-6", styles.item)}>
          {imageLeft && imageLeft.asset && (
            <figure>
              <img
                src={imageUrlFor(buildImageObj(imageLeft))
                  .auto("format")
                  .url()}
                alt={imageLeft.alt}
              />
              {imageLeft.caption && (<figcaption>{imageLeft.caption}</figcaption>)}
            </figure>
          )}
        </div>
        <div className="col-12 col-md-6">
          {imageRight && imageRight.asset && (
            <figure>
              <img
                src={imageUrlFor(buildImageObj(imageRight))
                  .auto("format")
                  .url()}
                alt={imageRight.alt}
              />
              {imageRight.caption && (<figcaption>{imageRight.caption}</figcaption>)}
            </figure>
          )}
        </div>
      </div>
    </div>
  );
}

export default TwoColumnImage;
